import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { HeroBlockSearchFormFields } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormFields';
import { HeroBlockSearchFormProvider, type HeroBlockSearchFormProviderProps } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormProvider';
import { HeroSearchFormMobileSearchBtn, type HeroSearchFormMobileSearchBtnProps } from '@/components/forms/HeroBlockSearchForm/components/HeroSearchFormMobileSearchBtn';
import type { AnalyticsInteractionEventParams } from '@/services/analytics/plugins/analyticsJucyInteraction';
export type ModalSearchFormBtnProps = {
  values?: HeroBlockSearchFormProviderProps['values'];
  openStep?: HeroSearchFormMobileSearchBtnProps['openStep'];
  children?: ReactNode;
  className?: string;
  trackInteraction?: AnalyticsInteractionEventParams;
};
export default function ModalSearchFormBtn(t0) {
  const $ = _c(11);
  const {
    values,
    openStep,
    children,
    className,
    trackInteraction
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== openStep || $[3] !== trackInteraction) {
    t1 = <HeroSearchFormMobileSearchBtn className={className} openStep={openStep} trackInteraction={trackInteraction}>{children}</HeroSearchFormMobileSearchBtn>;
    $[0] = children;
    $[1] = className;
    $[2] = openStep;
    $[3] = trackInteraction;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1 || $[6] !== values) {
    t2 = <HeroBlockSearchFormFields defaultValues={values}>{t1}</HeroBlockSearchFormFields>;
    $[5] = t1;
    $[6] = values;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== values) {
    t3 = <HeroBlockSearchFormProvider mode="modal" values={values}>{t2}</HeroBlockSearchFormProvider>;
    $[8] = t2;
    $[9] = values;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}